import appApi from '../../../../../api/app-api';
import globalSettingsStores from '../../../../../stores/settings-stores';
import { toast } from 'react-toastify';

export const deleteAttributeOperation = async (
  listId: number | undefined,
  attributeId: number | undefined,
) => {
  try {
    if (!listId || !attributeId) {
      toast.warn('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
      return;
    }

    await appApi.deleteClassAttribute(listId, attributeId);
    globalSettingsStores.fetchSetting();
  } catch (e) {
    console.error(
      `deleteAttributeOperation is failed with the listId: ${listId}, attributeId: ${attributeId} and the error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
  }
};
